import { getItemFromLocalStorage, setItemFromLocalStorage } from 'reactApp/appHelpers/localstorageHelpers';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderAiPhotoGenerationMailSpacePromoModal = () => {
    openPopupHelper({
        popupName: popupNames.AI_GENERATION_MAIL_SPACE_PROMO_MODAL,
    });
};

const LOCAL_STORAGE_KEY = 'ai-photo-generation-mail-space-promo-modal-show' as const;

export const getAiPhotoGenerationMailSpacePromoModalShown = () => getItemFromLocalStorage(LOCAL_STORAGE_KEY);

export const setAiPhotoGenerationMailSpacePromoModalShown = () => setItemFromLocalStorage(LOCAL_STORAGE_KEY, true);
